<template>
  <CDropdown variant="nav-item">
    <CDropdownToggle placement="bottom-end" class="py-1 d-flex align-items-center" :caret="false" style="
        /* background-color: #004aad; */
        color: white;
        /* border: 1px solid gray; */
        border-radius: 10px;
        padding: 20px;
      ">
      <!-- <i class="fa-light fa-circle-user"></i> -->
      <!-- <CAvatar :src="avatar" size="md" /> -->
      <font-awesome-icon icon="fa-regular fa-circle-user" style="font-size: 35px;" />
      &nbsp;
      <span class="ml-2" style="font-weight: bold; font-size: 20px;">{{ uType }}</span>
    </CDropdownToggle>

  </CDropdown>
</template>

<script>
import avatar from '@/assets/images/avatars/8.jpg'
import router from '@/router'
export default {
  name: 'AppHeaderDropdownAccnt',
  setup() {
    let userInf = JSON.parse(localStorage.getItem('UserInfo'))
    // console.log('USER INFO => ', userInf)
    let userType = 'Approver'

    if (userInf.UserIsAnApprover === false) {
      userType = 'Requestor'
      // localStorage.setItem('uType', userType);
    }
    else {
      userType = 'Approver'
      // localStorage.setItem('uType', userType);
    }
    return {
      avatar: avatar,
      itemsCount: 42,
      // userData: JSON.parse(localStorage.getItem('users')),
      userType,
      userInf,
    }
  },
  data() {
    return {
      currRoutes: '',
      legalEntity: [],
      // selectedEntitiy: '',
      breadcrumbs: '',
      uType: '',
    }
  },
  mounted() {
    this.getTitle()
  },
  methods: {
    getTitle() {
      this.breadcrumbs = ''
      let breadcrumbs2 = router.currentRoute.value.name
      this.currRoutes = breadcrumbs2
      let type = localStorage.getItem('uType');
      if (breadcrumbs2 == 'NEW REQUEST' && this.$route.query.id) {
        this.currRoutes = 'NEW REQUEST'

      }
      if (breadcrumbs2 == 'APPROVER VIEW' && this.$route.query.id) {
        this.currRoutes = 'REQUEST FOR PAYMENT'
        this.breadcrumbs = 'APPROVER VIEW'

      }
      if (breadcrumbs2 == 'Confirmation') {
        this.currRoutes = 'CONFIRMATION'
      }
      if (
        this.currRoutes == 'NEW REQUEST' ||
        this.currRoutes == 'REQUEST FOR PAYMENT' && !this.$route.query.id
      ) {
        this.uType = 'Requestor'

      }
      else {

        if (type == 'Approver' || this.currRoutes == 'APPROVE PAYMENT') {

          this.uType = 'Approver'
        }
        else {
          this.uType = 'Requestor'
        }
      }

    },
    profile() {
      this.$router.push('/user/user-profile')
    },
    changePassword() { },
    logout() {
      localStorage.removeItem('token')
      localStorage.removeItem('users')
      this.$router.push({ name: 'Login' })
    },
  },
}
</script>
